module.exports = {
  siteTitle: 'David Site', // <title>
  manifestName: 'David Yao',
  manifestShortName: 'Landing', // max 12 characters
  manifestStartUrl: '/',
  manifestBackgroundColor: '#663399',
  manifestThemeColor: '#663399',
  manifestDisplay: 'standalone',
  manifestIcon: 'src/assets/img/website-icon.png',
  pathPrefix: `/david-site/`, // This path is subpath of your hosting https://domain/portfolio
  authorName: 'David Yao',
  heading: 'Full Stack Developer',
  // social
  socialLinks: [
    {
      icon: 'fa-linkedin',
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/yao-david-6a297a117',
    },
    {
      icon: 'fa-github',
      name: 'Github',
      url: 'https://github.com/davidyao2011',
    },
    {
      icon: 'fa-twitter',
      name: 'Twitter',
      url: 'https://twitter.com/davidyao2011',
    },
    {
      icon: 'fa-facebook',
      name: 'Facebook',
      url: 'https://facebook.com/dawei.yao.16',
    },
    {
      icon: 'fa-envelope-o',
      name: 'Email',
      url: 'mailto:davidyao2011@hotmail.com',
    },
  ],
};
